import { createContext } from 'react';

const noop = () => {
  if (process.env.NODE_ENV === 'development') {
    console.warn('Please wrap your component by ChangesHistoryProvider');
  }
};

const defaultContext = {
  history: [],
  currentState: {},
  currentStateIndex: 0,
  onChange: noop,
  onChangeThemeSettings: noop,
  onChangeSection: noop,
  onChangeBlock: noop,
  goHistoryForward: noop,
  goHistoryBack: noop,
  clearHistory: noop,

  themeCache: null,
  themeCacheId: '',
  pageSlug: '/',
  setPageSlug: noop,
  initThemeCache: noop,
  initThemeTemplateCache: noop,
  deleteThemeCache: noop,
  handleIframeNavigate: noop,
};

export const ChangesHistoryContext = createContext(defaultContext);
